<!-- Home.vue -->

<template>
  <div class="home" style="width: 300px; margin: 150px auto">
    <!-- <PayPal amount="10.00" currency="USD" :client="credentials" env="sandbox">
    </PayPal> -->
    <div id="paypal-button-container"></div>
  </div>
</template>

<script>
// import PayPal from "vue-paypal-checkout";
import { CLIENT_ID } from "@/config/key";
import { createCharge } from "@/api/checkout";
export default {
  props: ["price", "serviceCode"],
  components: {
    // PayPal,
  },
  data() {
    return {
      CLIENT_ID: CLIENT_ID,
      loaded: false,
    };
  },
  created() {
    this.$store.dispatch("SET_NAVBAR", 4);
  },
  mounted() {
    this.paypalLoad();
  },
  methods: {
    paypalLoad() {
      const clientId = this.CLIENT_ID;
      const script = window.document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=USD`;
      script.addEventListener("load", this.serLoaded);
      window.document.body.append(script);
    },
    serLoaded() {
      this.loaded = true;
      window.paypal
        .Buttons({
          createOrder: (data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: this.price,
                    currency_code: "USD",
                  },
                },
              ],
            });
          },
          // Finalize the transaction
          onApprove: (data, actions) => {
            return actions.order.capture().then((details) => {
              let data = {
                serviceCode: this.serviceCode, // trial :'100', basic : '101', premmium : '102',
                price: this.price,
                paypayId: details.id,
                currency_code: "USD",
                details: details,
              };
              createCharge(data).then((res) => {
                if (res.data.status == 200) {
                  return alert("결제가 완료 되었습니다.");
                } else {
                  return alert(res.data.message);
                }
              });
            });
          },
        })
        .render("#paypal-button-container");
    },
  },
};
</script>
